import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'

const isClient = typeof window !== 'undefined';
if (isClient) {
    var L = require('leaflet'); // Importa o Leaflet apenas no lado do cliente
}

interface Props {
    lat: number
    lng: number
    zoom?: number
    isAdjusting?: boolean
    popupMessage?: string
    className?: string
    onCoordinatesChange?: (lat: number, lng: number) => void;
}

export default function MapOsm(props: Props) {
    const mapRef = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<L.Map | null>(null);
    const markerRef = useRef<L.Marker | null>(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    function addMessagePopup() {
        if (!mapInstance.current || !markerRef.current) return;

        if (props.popupMessage !== undefined) {
            markerRef.current?.bindPopup(props.popupMessage)

            mapInstance.current.on('click', () => {
                markerRef.current?.openPopup()
            })
        }
    }

    useEffect(() => {
        if (!mounted || !isClient || !mapRef.current || !props.lat || !props.lng) return;

        if (!mapInstance.current) {
            // Inicializa o mapa apenas uma vez
            mapInstance.current = L.map(mapRef.current, {
                zoomControl: false,
                attributionControl: false,
                dragging: false,
                touchZoom: false,
                doubleClickZoom: false,
                scrollWheelZoom: false
            }).setView([props.lat, props.lng], props.zoom || 15);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' }).addTo(mapInstance.current);

            // Adiciona marcador
            markerRef.current = L.marker([props.lat, props.lng], { draggable: false }).addTo(mapInstance.current);

            // Adiciona popup com a mensagem personalizada
            addMessagePopup();
        } else {
            // Atualiza a posição do mapa e marcador
            mapInstance.current.setView([props.lat, props.lng]);
            markerRef.current?.setLatLng([props.lat, props.lng]);
        }
    }, [props.lat, props.lng, props.zoom, props.popupMessage, mounted]);

    useEffect(() => {
        if (!mapInstance.current || !markerRef.current) return;

        if (props.isAdjusting) {
            markerRef.current?.closePopup();
            markerRef.current?.unbindPopup();
            mapInstance.current.off('click');

            mapInstance.current.dragging.enable();
            mapInstance.current.touchZoom.enable();
            mapInstance.current.doubleClickZoom.enable();
            mapInstance.current.scrollWheelZoom.enable();

            mapInstance.current.on('move', () => {
                const newLatLng = mapInstance.current!.getCenter();
                markerRef.current?.setLatLng(newLatLng);
                props.onCoordinatesChange?.(newLatLng.lat, newLatLng.lng);
            });
        } else {
            mapInstance.current.dragging.disable();
            mapInstance.current.touchZoom.disable();
            mapInstance.current.doubleClickZoom.disable();
            mapInstance.current.scrollWheelZoom.disable();
            mapInstance.current.off('move');

            addMessagePopup();
        }
    }, [props.isAdjusting]);

    return (mounted && props.lat && props.lng) ? <div ref={mapRef} className={`${styles.container} ${props.className || ''}`} /> : <></>;
}